import * as Vue from 'vue';
import Navbar from "./Navbar.vue";
import {$} from 'jquery';
import {} from 'bootstrap';

interface CounterData {
    counter: number;
}

const Counter = {
    data(): CounterData {
        return {
            counter: 0
        }
    },

    mounted(): void {
        setInterval(() => {
            this.counter++;
        }, 1000);
    }
}

const app = Vue.createApp(Counter);

app.component('navbar', Navbar);

app.mount('#counter');